import { useEffect } from "react";
import Header from "@/components/Header";
import Footer from "@/components/Footer";
import Hero from "@/sections/Hero";
import CPE from "@/sections/CPE";
import DecretTertiaire from "@/sections/DecretTertiaire";
import CEE from "@/sections/CEE";
import Travaux from "@/sections/Travaux";
import Parcours from "@/sections/Parcours";
import Outils from "@/sections/Outils";
import FaqSection from "@/sections/FaqSection";
import BlogSection from "@/sections/BlogSection";
import Contact from "@/sections/Contact";

export default function Home() {
  useEffect(() => {
    document.title = "PRIMEC2E · Contrat de Performance Énergétique, Décret Tertiaire & CEE";
    // scroll to hash after mount
    if (window.location.hash) {
      const el = document.querySelector(window.location.hash);
      if (el) setTimeout(() => el.scrollIntoView({ behavior: "smooth" }), 200);
    }
  }, []);

  return (
    <div className="bg-white">
      <Header />
      <main>
        <Hero />
        <CPE />
        <DecretTertiaire />
        <CEE />
        <Travaux />
        <Parcours />
        <Outils />
        <FaqSection />
        <BlogSection />
        <Contact />
      </main>
      <Footer />
    </div>
  );
}
